import React from 'react';
import { useParams } from 'react-router';
import PageContainer from '../../layout/PageContainer';
import CorredorLiquidacionDetalle from '../liquidacion/CorredorLiquidacionDetalle';

const CorredorLiquidacionCreditoDetalleContainer = () => {
  const { liquidacionId } = useParams();
  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        { id: 1, name: 'CORREDOR', url: '/corredor/polizas-credito' },
        { id: 2, name: 'LIQUIDACIÓN CRÉDITO', url: '/corredor/liquidacion-credito' },
        { id: 3, name: 'DETALLE' },
      ]}
      clientFilter={{
        type: 'corredor',
        ramo: 'credito',
        showFilter: false,
      }}
    >
      {(corredor) => (
        <CorredorLiquidacionDetalle
          liquidacionId={liquidacionId}
          corredor={corredor}
          tipo="credito"
        />
      )}
    </PageContainer>
  );
};

export default CorredorLiquidacionCreditoDetalleContainer;
